module.exports = __webpack_public_path__ + "img/alyssa-li-n2z5UL4E4Og-unsplash.dd55ca8c.jpg";